import React from 'react';
import errorlogo from '../Assets/Images/fix-403-Forbidden-Error.png';
import { Container } from '@material-ui/core';

export default function Errorpage()
{
    return(
           <div>
            <img src={errorlogo} alt="loading..." style={{marginLeft:'350px',marginTop:'100px'}}/>
            </div>
    )

}

